import sessionStoreEx from 'bundles/common/utils/sessionStorageEx';

export const persistantChatSessionId = {
  get: (key: string) => {
    const chatSessionIdFromMemory = sessionStoreEx.getItem<string>(key, (value) => value, '');
    const sanitizedChatSessionId =
      chatSessionIdFromMemory && chatSessionIdFromMemory !== 'undefined' ? chatSessionIdFromMemory : undefined;
    return sanitizedChatSessionId;
  },
  set: (key: string, sessionId: string) => {
    const chatSessionId = sessionId;
    sessionStoreEx.setItem(key, chatSessionId, (value) => value);
  },
  clear: (key: string) => {
    sessionStoreEx.removeItem(key);
  },
};
